


































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Button from "@/shared/components/ui/Button.vue";
import Input from "@/shared/components/ui/Input.vue";
import { FetchState } from "@/shared/types";
import { useUserSystemIdStore } from "@/shared/store/userSystemId";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    GenericLoadingSpinner,
    Input,
    Button
  }
})
export default class AccountHolderUserSystemId extends Vue {
  canEdit = false;
  newUserSystemId: string = null;
  userStore = useUserStore();
  userSystemIdStore = useUserSystemIdStore();

  @Prop()
  username: string;

  @Prop()
  partnerId: number;

  mounted () {
    if (this.userStore.isAdmin) {
      this.userSystemIdStore.loadUsername({
        partnerId: this.partnerId,
        username: this.username
      });
    }
  }

  get isShown () {
    return this.userStore.isAdmin && this.userSystemIdStore.needsSystemId;
  }

  get isLoading () {
    return !this.isLoaded;
  }

  get isLoaded () {
    return this.userSystemIdStore.fetchState === FetchState.Loaded;
  }

  @Watch("userSystemIdStore.userSystemId")
  userSystemIdChanged () {
    if (this.newUserSystemId === null) {
      this.newUserSystemId = this.userSystemIdStore.userSystemId;
    }
  }

  editClicked () {
    this.canEdit = true;
  }

  cancelClicked () {
    this.canEdit = false;
  }

  submitClicked () {
    if (this.isLoading) {
      return;
    }

    this.userSystemIdStore.beginSetUserSystemId({
      partnerId: this.partnerId,
      userSystemId: this.newUserSystemId
    })
      .then(_ => {
        this.newUserSystemId = this.userSystemIdStore.userSystemId;
        this.canEdit = false;
      });
  }
}
